/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EListSearchType } from './EListSearchType';
import {
    EListSearchTypeFromJSON,
    EListSearchTypeFromJSONTyped,
    EListSearchTypeToJSON,
} from './EListSearchType';
import type { EListSearchTypeESearchCctTypeCombinableCriteria } from './EListSearchTypeESearchCctTypeCombinableCriteria';
import {
    EListSearchTypeESearchCctTypeCombinableCriteriaFromJSON,
    EListSearchTypeESearchCctTypeCombinableCriteriaFromJSONTyped,
    EListSearchTypeESearchCctTypeCombinableCriteriaToJSON,
} from './EListSearchTypeESearchCctTypeCombinableCriteria';
import type { ESearchCctType } from './ESearchCctType';
import {
    ESearchCctTypeFromJSON,
    ESearchCctTypeFromJSONTyped,
    ESearchCctTypeToJSON,
} from './ESearchCctType';

/**
 * 
 * @export
 * @interface ESearchCctTypeListSearch
 */
export interface ESearchCctTypeListSearch {
    /**
     * 
     * @type {Array<EListSearchTypeESearchCctTypeCombinableCriteria>}
     * @memberof ESearchCctTypeListSearch
     */
    criterias?: Array<EListSearchTypeESearchCctTypeCombinableCriteria> | null;
    /**
     * 
     * @type {EListSearchType}
     * @memberof ESearchCctTypeListSearch
     */
    searchMode?: EListSearchType;
    /**
     * 
     * @type {ESearchCctType}
     * @memberof ESearchCctTypeListSearch
     */
    value?: ESearchCctType;
    /**
     * 
     * @type {ESearchCctType}
     * @memberof ESearchCctTypeListSearch
     */
    secondaryValue?: ESearchCctType;
    /**
     * 
     * @type {Array<string>}
     * @memberof ESearchCctTypeListSearch
     */
    readonly availableSearchTypes?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ESearchCctTypeListSearch
     */
    defaultSearchType?: string | null;
}

/**
 * Check if a given object implements the ESearchCctTypeListSearch interface.
 */
export function instanceOfESearchCctTypeListSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ESearchCctTypeListSearchFromJSON(json: any): ESearchCctTypeListSearch {
    return ESearchCctTypeListSearchFromJSONTyped(json, false);
}

export function ESearchCctTypeListSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): ESearchCctTypeListSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'criterias': !exists(json, 'criterias') ? undefined : (json['criterias'] === null ? null : (json['criterias'] as Array<any>).map(EListSearchTypeESearchCctTypeCombinableCriteriaFromJSON)),
        'searchMode': !exists(json, 'searchMode') ? undefined : EListSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : ESearchCctTypeFromJSON(json['value']),
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : ESearchCctTypeFromJSON(json['secondaryValue']),
        'availableSearchTypes': !exists(json, 'availableSearchTypes') ? undefined : json['availableSearchTypes'],
        'defaultSearchType': !exists(json, 'defaultSearchType') ? undefined : json['defaultSearchType'],
    };
}

export function ESearchCctTypeListSearchToJSON(value?: ESearchCctTypeListSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'criterias': value.criterias === undefined ? undefined : (value.criterias === null ? null : (value.criterias as Array<any>).map(EListSearchTypeESearchCctTypeCombinableCriteriaToJSON)),
        'searchMode': EListSearchTypeToJSON(value.searchMode),
        'value': ESearchCctTypeToJSON(value.value),
        'secondaryValue': ESearchCctTypeToJSON(value.secondaryValue),
        'defaultSearchType': value.defaultSearchType,
    };
}

